/**
 * Compile-time Feature Flags / Nav-Konfiguration.
 * Nach Änderung: Frontend neu bauen/deployen.
 */
export const FEATURE_FLAGS = {
    /**
     * Links zu /liga/1-bundesliga/playoffs:
     * Desktop-Nav (Top-Level + Untermenü 1. BL), Mobile-Nav (Top-Level), Home-Button.
     * Die Liga-Subnavigation steuert sich weiterhin über vorhandene playoff_v2_*.json.
     */
    showPlayoffsLinks: false,

    /**
     * Erklär-Seite Play-Offs im Submenü 1. Bundesliga (zwischen Tabelle und Statistiken).
     * Pfad relativ zur Site (CMS-Info-Seite).
     */
    playoffsInfoPath: '/info/wie-funktionieren-die-play-offs-2627',

    /**
     * Team-Transfer-Übersicht (Subnav + Route). Temporär ausblenden bis Lizenzdaten stehen.
     */
    showTeamTransfers: false,

    /**
     * Super-Cup-Match im Nav (Desktop + Mobile Untermenü).
     * Jährlich aktualisieren (matchId, label).
     */
    superCupMatch: {
        matchId: 90058,
        leagueId: 4,
        label: 'Rexel Super Cup 2026',
    },

    /**
     * Runden-Label je Super-Cup-Saison (fmpSeasonId → Config).
     * Pro neuer Saison einen Eintrag ergänzen; frühere Einträge bleiben erhalten.
     * Wert unter „Runde:“ (MatchView) / MatchCard-Header.
     */
    superCupRoundBySeason: {
        1740: { roundLabel: 'Rexel Super Cup' },
    },

    /**
     * Aktive Saison (Startjahr, z.B. 2025 = 2025/26).
     * Source of Truth für Default-fmpSeasonId aller Wettbewerbe (siehe seasons.js).
     * CMS-fmpSeasonId wird nur noch als Fallback genutzt, wenn kein Map-Eintrag existiert.
     * Testsystem: auf 2026 setzen, um die neue Saison unabhängig vom CMS-Stand zu sehen.
     */
    activeSeasonYear: 2026,

    /**
     * Saisonauswahl in der Liga-Subnavigation (year-Filter).
     * maxYear anheben, sobald die nächste Saison im Dropdown erscheinen soll.
     * Die aktive Saison ist immer wählbar (siehe LeagueSubNavigation).
     */
    seasonSelect: {
        minYear: 2022,
        maxYear: 2026,
    },
};

export function superCupMatchPath() {
    const { matchId, leagueId } = FEATURE_FLAGS.superCupMatch;
    return `/match/${matchId}/${leagueId}`;
}

/**
 * Runden-Label für eine Super-Cup-Saison aus dem Mapping (sonst null).
 */
export function superCupRoundLabelForSeason(fmpSeasonId) {
    if (fmpSeasonId == null || fmpSeasonId === '') {
        return null;
    }
    const entry = FEATURE_FLAGS.superCupRoundBySeason[Number(fmpSeasonId)];
    return entry && entry.roundLabel ? entry.roundLabel : null;
}
